import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2, CalendarClock } from "lucide-react";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const inputCls = "rounded-none border-[var(--trio-border)] bg-[var(--trio-bg)]";

export const BrunchScheduleEditor = ({ menu, setMenu }) => {
  const set = (patch) => setMenu({ ...menu, ...patch });
  const toggleDay = (d) =>
    set({ days: menu.days.includes(d) ? menu.days.filter((x) => x !== d) : [...menu.days, d] });
  const setSpecial = (i, patch) =>
    set({ special_days: menu.special_days.map((s, k) => (k === i ? { ...s, ...patch } : s)) });

  return (
    <div data-testid="brunch-schedule" className="border border-[var(--trio-border)] bg-[var(--trio-surface)] p-4 space-y-4">
      <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[var(--trio-primary)] font-bold">
        <CalendarClock className="w-3.5 h-3.5" /> Brunch Schedule (controls the "Brunch Today" homepage banner)
      </div>
      <div className="flex flex-wrap gap-2 items-end">
        {DAYS.map((d, i) => (
          <button
            key={d}
            type="button"
            onClick={() => toggleDay(i)}
            data-testid={`brunch-day-${i}`}
            className={`px-3 py-2 text-xs uppercase tracking-widest border transition-colors ${
              menu.days.includes(i) ? "bg-[var(--trio-primary)] text-white border-[var(--trio-primary)]" : "border-[var(--trio-border)]"
            }`}
          >
            {d}
          </button>
        ))}
        <div>
          <Label className="text-[10px] tracking-widest uppercase">Starts</Label>
          <Input type="time" value={menu.start} onChange={(e) => set({ start: e.target.value })} data-testid="brunch-start" className={`mt-1 ${inputCls}`} />
        </div>
        <div>
          <Label className="text-[10px] tracking-widest uppercase">Ends</Label>
          <Input type="time" value={menu.end} onChange={(e) => set({ end: e.target.value })} data-testid="brunch-end" className={`mt-1 ${inputCls}`} />
        </div>
      </div>
      <div className="space-y-2">
        <Label className="text-[10px] tracking-widest uppercase">Special days (override hours, e.g. Breakfast Club)</Label>
        {menu.special_days.map((s, i) => (
          <div key={i} data-testid={`brunch-special-${i}`} className="flex flex-wrap gap-2 items-center">
            <Input type="date" value={s.date} onChange={(e) => setSpecial(i, { date: e.target.value })} data-testid={`brunch-special-${i}-date`} className={`${inputCls} w-40`} />
            <Input type="time" value={s.start} onChange={(e) => setSpecial(i, { start: e.target.value })} data-testid={`brunch-special-${i}-start`} className={`${inputCls} w-32`} />
            <Input type="time" value={s.end} onChange={(e) => setSpecial(i, { end: e.target.value })} data-testid={`brunch-special-${i}-end`} className={`${inputCls} w-32`} />
            <Input value={s.label || ""} onChange={(e) => setSpecial(i, { label: e.target.value })} placeholder="Label (e.g. Breakfast Club)" data-testid={`brunch-special-${i}-label`} className={`${inputCls} flex-1 min-w-[160px]`} />
            <button type="button" onClick={() => set({ special_days: menu.special_days.filter((_, k) => k !== i) })} data-testid={`brunch-special-${i}-remove`} className="p-2 text-red-700" title="Remove">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => set({ special_days: [...menu.special_days, { date: "", start: "09:00", end: "15:00", label: "Breakfast Club" }] })}
          data-testid="brunch-special-add"
          className="inline-flex items-center gap-1 text-xs uppercase tracking-widest font-bold text-[var(--trio-primary)]"
        >
          <Plus className="w-3.5 h-3.5" /> Add special day
        </button>
      </div>
    </div>
  );
};
